import { Box } from '@mui/material';
import React from 'react';
import ErrorMessage from '@shared/components/ErrorMessage';
import { StyledTextField } from '../styles/review.styles';
import { StyledQuestionText } from './question_types/ReviewMultipleChoiceQuestion';

interface AddCompanyFormProps {
  newCompany: { companyName: string; stockTicker: string };
  setNewCompany: React.Dispatch<
    React.SetStateAction<{ companyName: string; stockTicker: string }>
  >;
  errors: Record<string, string>;
}

const AddCompanyForm: React.FC<AddCompanyFormProps> = ({
  newCompany,
  setNewCompany,
  errors,
}) => {
  return (
    <>
      <Box sx={{ marginBottom: 'var(--spacing-md)' }}>
        <StyledQuestionText>
          What is the name of the company you are reviewing?
        </StyledQuestionText>
        <div style={{ width: '80%' }}>
          <StyledTextField
            data-testid="new-company-name-input"
            onChange={e =>
              setNewCompany({
                ...newCompany,
                companyName: e.target.value,
              })}
            size="small"
            value={newCompany.companyName}
            required
          />
          {errors.economicBuyerName && (
            <ErrorMessage error={errors.economicBuyerName} />
          )}
        </div>
      </Box>
      <Box sx={{ marginBottom: 'var(--spacing-md)' }}>
        <StyledQuestionText>
          What is the stock ticker of the company you are reviewing?
        </StyledQuestionText>
        <div style={{ width: '80%' }}>
          <StyledTextField
            data-testid="new-company-stock-ticker-input"
            onChange={e =>
              setNewCompany({
                ...newCompany,
                stockTicker: e.target.value,
              })}
            size="small"
          />
          {errors.economicBuyerName && (
            <ErrorMessage error={errors.economicBuyerName} />
          )}
        </div>
      </Box>
    </>
  );
};

export default AddCompanyForm;
